import { render, staticRenderFns } from "./KabPegununganBintang.vue?vue&type=template&id=7847b183"
import script from "./KabPegununganBintang.vue?vue&type=script&lang=js"
export * from "./KabPegununganBintang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports